module.exports = __webpack_public_path__ + "img/Teaching-Hello-Code.0473bad0.jpg";